import { useNavigate } from 'react-router-dom';
import { signOut } from '@/lib/auth';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { ThemeToggle } from '@/components/ui/ThemeToggle';

export default function Unauthorized() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen w-full bg-surface flex items-center justify-center px-4 relative">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <Card glass className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <div className="flex flex-col items-center gap-1 mb-2">
              <h1 className="text-2xl font-bold text-text-primary tracking-tight">Rainmaker</h1>
              <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">
                Admin
              </span>
            </div>
          </div>
          <h2 className="text-2xl font-semibold text-text-primary">Access Denied</h2>
        </div>

        <div className="space-y-6 text-center">
          <p className="text-text-secondary text-sm">
            You don't have admin access. If this is a mistake, contact your administrator.
          </p>
          <Button variant="primary" className="w-full" onClick={handleSignOut}>
            Sign Out
          </Button>
        </div>
      </Card>
    </div>
  );
}
